import React, { useState, useCallback, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import {
  MenuItem,
  Select,
  TextField,
  Button
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box'
import Autocomplete from '@mui/material/Autocomplete'
import RoomIcon from '@mui/icons-material/Room'
import { getCalFareFormat, getMonthsCalendarFare } from '../../../core/helper'
import { API_BASE_URL } from '../../../utility/apiConstants'
import { getAuth } from '../../../utility/apiConfig'
import { depVali, fromVali, toVali } from './flightSearchValidation'
import { useHistory } from 'react-router'
import swipe from '../../../assets/images/swipe.svg'
import { airports } from '../../../services/airportList'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}))

const CalendareFare = () => {
  const classes = useStyles()

  const history = useHistory()

  const [classType, setClassType] = useState(1)
  const [calendareFare, setCalendareFare] = useState({
    adult: 1,
    cabin: 'Economy',
    carrier: '',
    depature: '',
    from: '',
    from_loc: '',
    from_location: '',
    return: '',
    to: '',
    to_loc: '',
    to_location: '',
    trip_type: 'OneWay'

  })

  const [calendareError, setCalendareError] = useState({
    fromError: '',
    toError: '',
    depatureError: ''
  })

  const [fromAirport, setFromAirport] = useState([])
  const [fromValue, setFromValue] = useState(null)
  const [toAirport, setToAirport] = useState([])
  const [toValue, setToValue] = useState(null)
  const [prefAirline, setprefAirline] = useState([])
  const [prefAirValue, setPrefAirValue] = useState(null)
  const [monthYear, setMonthYear] = useState(false)

  // const getFromAirportList = useCallback(
  //   (search) => {
  //     getAuth(API_BASE_URL + 'data/get_airport_code_list/' + search, null)
  //       .then((response) => {
  //         let newOptions = []
  //         if (response.data.status) {
  //           newOptions = [...newOptions, ...(response.data.data)]
  //         }
  //         setFromAirport(newOptions)
  //       }).catch((error) => {
  //       })
  //   })

  // const getToAirportList = useCallback(
  //   (search) => {
  //     getAuth(API_BASE_URL + 'data/get_airport_code_list/' + search, null)
  //       .then((response) => {
  //         let newOptions = []
  //         if (response.data.status) {
  //           newOptions = [...newOptions, ...(response.data.data)]
  //         }
  //         setToAirport(newOptions)
  //       }).catch((error) => {
  //       })
  //   })

  // const getAirportList = (search) => {
  //   try {
  //     getAuth(API_BASE_URL + 'data/get_airport_code_list/' + search, null)
  //       .then((response) => {

  //         if (response.data.status) {
  //           setFromAirport(response.data.data)
  //           setToAirport(response.data.data)
  //         } else {
  //           setFromAirport([])
  //           setToAirport([])
  //         }
  //       }).catch((error) => {
  //       })
  //   } catch (error) {
  //   }
  // }

  const airportSwitch = () => {
    setToValue(fromValue)
    setFromValue(toValue)
  }

  const filterOptions = (options, state) => {
    const { inputValue } = state

    if (!inputValue) {
      return options.slice(0, 10)
    }
    const arr = airports.filter((item) => {
      return item.airport_code.toLowerCase() === inputValue.toLowerCase()
    })

    if (arr && arr.length > 0) {
      return arr
    } else {
      const cityArr = airports.filter((item) => {
        return item.airport_city.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      })
      return cityArr && cityArr.length > 0 ? cityArr.slice(0, 20) : []
    }
  }

  const getAirline = useCallback(
    (searching) => {
      try {
        getAuth(API_BASE_URL + 'data/get_airline/' + searching, null)
          .then((response) => {

            if (response.data.status) {
              setprefAirline(response.data.data)
            } else {
              setprefAirline([])
            }
          }).catch((error) => {
          })
      } catch (error) {
      }
    })

  const handleClassClose = () => {
    setMonthYear(false)
  }

  const handleClassOpen = () => {
    setMonthYear(true)
  }

  const handleClassChange = (event) => {
    console.log("Event",event.target.value)
    setClassType(event.target.value)

    setCalendareFare({
      ...calendareFare,
      depature: getCalFareFormat(event.target.value)
    })

    setCalendareError({
      ...calendareFare,
      depatureError: ''
    })
  }

  const handleDefaultClassChange = (event) => {
    setClassType(event);

    setCalendareFare({
      ...calendareFare,
      depature: getCalFareFormat(event)
    })

    setCalendareError({
      ...calendareFare,
      depatureError: ''
    })
  }

  const handleCalendareFare = () => {
    const fromEr = fromVali(calendareFare.from)
    const toEr = toVali(calendareFare.to)
    const depEr = depVali(calendareFare.depature)

    if (fromEr || toEr || depEr) {
      setCalendareError({
        ...calendareFare,
        fromError: fromEr,
        toError: toEr,
        depatureError: depEr
      })
      return
    }

    history.push({
      pathname: '/flight/calendar',
      state: calendareFare
    })
  }

  useEffect(() => {
  //  getAirportList('');
    handleDefaultClassChange(getMonthsCalendarFare().map((item) => item)[0]);
  }, [])

  return (
    <div>
      <Box>
        <form className={classes.root} noValidate autoComplete="off">
          <Box className="search-wpr">
            <Grid container spacing={1} className="cntrowswp">
              <Grid item md={3} xs={12} className="prstColl mob-input-border">
                <Box textAlign="left" className="box-tlt box-input-w">
                  <span>From</span>
                  <Autocomplete
                    className="inputFieldLocation"
                    size="small"
                    id="free-solo-demo"
                    freeSolo
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    options={airports}
                    filterOptions={filterOptions}
                    getOptionLabel={(option) => option.airport_city + " (" +option.airport_code + ")"}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <Box className="searchsuggestionbox">
                          <Box className="flightdetails-code">
                            <Box className="cityfly">{option.airport_city}, {option.country}</Box>
                            <Box className="airportcode">{option.airport_code}</Box>
                          </Box>
                          <Box className="airport-name">{option.airport_name}</Box>
                        </Box>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        placeholder="Type atleast 3 letters"
                        className="inputFieldLocation"
                        error={!!calendareError.fromError}
                        helperText={calendareError.fromError}

                      />
                    )}
                    value={fromValue}
                    onChange={(event, newValue) => {
                      setCalendareError({ ...calendareError, fromError: '' })
                      setFromAirport(newValue ? [newValue, ...fromAirport] : fromAirport)
                      setFromValue(newValue)
                      if (newValue) {
                        setCalendareFare({
                          ...calendareFare,
                          from: newValue.airport_code,
                          from_loc: newValue.airport_code,
                          from_location: newValue.airport_code
                        })
                      } else {
                        setCalendareFare({
                          ...calendareFare,
                          from: '',
                          from_loc: '',
                          from_location: ''
                        })
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item md={1} xs={12} className="prstColl">
                <Box className="box-swpicon-w">
                  <Box className="icoswipe swipebox" onClick={airportSwitch}><SwapHorizIcon /></Box>
                </Box>
              </Grid>

              <Grid item md={3} xs={12} className="prstColl mob-input-border">
                <Box textAlign="left" className="box-tlt box-input-w">
                  <span>To</span>
                  <Autocomplete
                    className="inputFieldLocation"
                    size="small"
                    id="free-solo-demo"
                    freeSolo
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    options={airports}
                    filterOptions={filterOptions}
                    getOptionLabel={(option) => option.airport_city + " (" +option.airport_code + ")"}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <Box className="searchsuggestionbox">
                          <Box className="flightdetails-code">
                            <Box className="cityfly">{option.airport_city}, {option.country}</Box>
                            <Box className="airportcode">{option.airport_code}</Box>
                          </Box>
                          <Box className="airport-name">{option.airport_name}</Box>
                        </Box>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        placeholder="Type atleast 3 letters"
                        className="inputFieldLocation"
                        error={!!calendareError.toError}
                        helperText={calendareError.toError}
                      />
                    )}

                    // filterOptions={(x) => x}
                    value={toValue}
                    onChange={(event, newValue) => {
                      setCalendareError({ ...calendareError, toError: '' })
                      setToAirport(newValue ? [newValue, ...toAirport] : toAirport)
                      setToValue(newValue)
                      if (newValue) {
                        if (newValue) {
                          setCalendareFare({
                            ...calendareFare,
                            to: newValue.airport_code,
                            to_loc: newValue.airport_code,
                            to_location: newValue.airport_code
                          })
                        } else {
                          setCalendareFare({
                            ...calendareFare,
                            to: '',
                            to_loc: '',
                            to_location: ''
                          })
                        }
                      }
                    }}
                    // onInputChange={(event, newInputValue) => {
                    //   if (newInputValue) {
                    //     getToAirportList(newInputValue)
                    //   }
                    // }}
                    clearOnEscape={true}

                  />
                </Box>
              </Grid>
              <Grid item md={5} xs={12} className="prstColl d-flex mob-input-border month-year-wrp">
                <span className='border-right div-border-right'></span>
                <Box textAlign="left" className="box-tlt box-input-calender  my-input">
                  <Box textAlign="left" className="box-tlt">
                    Month & year
                  </Box>
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    open={monthYear}
                    onClose={handleClassClose}
                    onOpen={handleClassOpen}
                    value={classType}
                    onChange={handleClassChange}
                    variant="outlined"
                    className="ClassSelector"
                    error={!!calendareError.depatureError}
                    helperText={calendareError.depatureError}
                  >

                    {
                      getMonthsCalendarFare().map((item, index) => {
                        return (<MenuItem
                          className="items-list"
                          selected={index == 0 ? 'true' : ' '}
                          value={item}
                        >
                          {item}
                        </MenuItem>)
                      })
                    }
                  </Select>
                </Box>
                
                
              </Grid>
            </Grid>
          </Box>
          {/* <Grid container spacing={1}>
            <Grid item lg={4}></Grid>
            <Grid item lg={12}>
              <Box className="lineBar"></Box>
            </Grid>
          </Grid> */}

          <Grid container spacing={1}>
            <Grid item md={5} xs={3}></Grid>
            <Grid item md={5} xs={3}></Grid>
            <Grid item md={2} xs={6}>
              <Button
                variant="contained"
                color="primary"
                className="btnSend"
                onClick={handleCalendareFare}
              >
                Search
              </Button>
            </Grid>
          </Grid>
       
      </form>
    </Box>

  </div>
  )
}

export default CalendareFare
